/**
 * Header component.
 * @module components/theme/Header/Header
 */

import React from 'react';

import PropTypes from 'prop-types';

import {
    Navigation,
} from '@plone/volto/components';

import {
    HeaderSlimUniba,
    HeaderCenterUniba,
    HeaderBannerUniba,
    SubsiteHeader,
} from 'design-comuni-plone-theme/components/ItaliaTheme';
import { Headers } from 'design-react-kit';

const Header = ({ pathname }) => {
    return (
        <>
            <div className="public-ui">
                <header>
                    <Headers>
                        <HeaderSlimUniba />
                        <div className="it-nav-wrapper">
                            <HeaderCenterUniba />
                            <HeaderBannerUniba />
                            <Navigation pathname={pathname} />
                        </div>
                    </Headers>
                    <SubsiteHeader />
                </header>
            </div>

            <div id="portal-header-image"></div>
        </>
    );
};

Header.propTypes = {
    pathname: PropTypes.string.isRequired,
};

export default Header;
